export const PARTIFY_PRESETS = [
  {
    id: 'classic',
    name: 'Classic',
    colors: ['#FF6B6B', '#FF6BB5', '#FF81FF', '#FF81FF', '#D081FF', '#81ACFF', '#81FFFF', '#81FF81', '#FFD081', '#FF8181'],
  },
  { id: 'rainbow', name: 'Rainbow', colors: ['#FF0000', '#FFFF00', '#00FF00', '#00FFFF', '#0000FF', '#FF00FF'] },
  { id: 'sunset', name: 'Sunset', colors: ['#FFCC66', '#FF9966', '#FF6699', '#CC66CC', '#9966CC'] },
  { id: 'ocean', name: 'Ocean', colors: ['#0066CC', '#0099CC', '#00CCCC', '#66FFCC', '#66CCFF'] },
];

export const DEFAULT_PARTIFY_COLORS = PARTIFY_PRESETS[0].colors;
export const MIN_PARTIFY_COLORS = 2;
export const MAX_PARTIFY_COLORS = 12;
export const isValidPartifyColor = color => /^#[0-9a-f]{6}$/i.test(color);
